<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="esops"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="otherBtn">
        <up-load-file
            v-if="limits.uploadAuth"
            ref="upload"
            :file-type="fileType"
            :auth-index="authIndex"
            @upload-success="uploadSuccess"/>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <down-load-file v-if="limits.downloadAuth" :file-key="scope.row.filePath"/>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="ESOP编号">
            <el-input v-model.trim="filter.EsopNo" placeholder="请输入ESOP编号" clearable/>
          </el-form-item>
          <el-form-item label="ESOP名称">
            <el-input v-model.trim="filter.EsopName" placeholder="请输入ESOP名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <esop-edit ref="esopEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import UpLoadFile from "@/components/UploadFile.vue";
  import DownLoadFile from "@/components/DownLoadFile.vue";
  import EsopEdit from "./EsopEdit";
  export default {
    components: { viewTable, UpLoadFile, DownLoadFile, EsopEdit },
    data() {
      return {
        fileType: ["pdf"],
        authIndex: this.$route.meta.authIndex,
        limits: {
          editAuth: this.$auth(741),
          downloadAuth: this.$auth(744),
          delAuth: this.$auth(742),
          uploadAuth: this.$auth(743),
        },
        filter: {},
        columnsProperty: [
          {
            key: "esopNo",
            width: 120,
            align: "center",
          },
          {
            key: "esopName",
            minWidth: 150,
          },
          {
            key: "filePath",
            minWidth: 150,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 190,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      // 新增、编辑
      addEditHandle(row) {
        this.$refs.esopEdit.open(row);
      },

      // 加载数据
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "esops", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            esopName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.$http.save("basic", "esops", params).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("文件上传成功");
            }
          });
        }
      },

      resetHandle(filter) {
        this.filter = filter;
      },

    //替换文件
    // exchangeFile(file) {
    //   this.$http.get("basic", `files/getUploadUrl?filename=${file.file.name}&authIndex=${this.authIndex}`).then((res) => {
    //     if (res.success) {
    //       axios({
    //         method: "PUT",
    //         headers: res.data.headers,
    //         url: res.data.url,
    //         data: file.file,
    //         onUploadProgress: (progressEvent) => {
    //           this.percentage = Number(((progressEvent.loaded / progressEvent.total) * 100).toFixed(0));
    //         },
    //       }).then(() => {
    //         this.fileList.forEach((item) => {
    //           if (item.name == file.file.name) {
    //             item.key = res.data.key;
    //           }
    //         });
    //         if (this.percentage === 100) {
    //           const params = {
    //             pkid: this.index,
    //             fileName: this.fileList[0].name,
    //             filePath: this.fileList[0].key,
    //           };
    //           this.$http
    //             .post("basic", "esops/replaceEsop", params)
    //             .then((res) => {
    //               if (res.success) {
    //                 this.$message.success("替换成功！");
    //                 this.getList(1);
    //               }
    //             })
    //             .catch(() => {
    //               this.$message.error("替换失败！");
    //             });
    //         }
    //       });
    //     }
    //   });
    // },
    },
  };
</script>
